import React, { Component } from 'react';
import { Grid, Segment, Button, Icon } from 'semantic-ui-react';
import BreadcrumbCustom from './../layout/BreadcrumbCustom';
//import { Bar } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { getDashBoardDetails } from './../utils/rest';
import VideoPlayer from '../components/VideoPlayer';
class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: 'React',
        };
    }

    componentDidMount() {
        this.getDashBoard();
    }
    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.getDashBoard();
        }
    }

    getDashBoard = () => {
        getDashBoardDetails(this.props.items.currentCorporate).then((response) => {
            if (response !== null && (response instanceof Object)) {
                this.props.addItem("countDetails", response);
            }
        })
    }

    render() {
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="" child={[{ name: "Dashboard", url: null }]} />
                <Grid className="g-bkgd dashboard">
                    <Grid.Column>
                        <Grid>
                            <Grid.Column width={4} className="wide">
                                <Segment className="grey">
                                    <h5 className="ui header"><i className="cog icon"></i>Unsubmitted Accounts</h5>
                                    <p>[{this.props.items.countDetails.unSubmittedAccountCount ? this.props.items.countDetails.unSubmittedAccountCount : 0}]</p>
                                    <Button as={Link} to={"/account"} className="ui right labeled icon small button grey">
                                        <Icon name="linkify" />
                                        View Batch
                                    </Button>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column width={4} className="wide">
                                <Segment className="grey">
                                    <h5 className="ui header"><i className="pause icon"></i>Your Requested Holds</h5>
                                    <p>[{this.props.items.countDetails.requestedHoldCount ? this.props.items.countDetails.requestedHoldCount : 0}]</p>
                                    <Button as={Link} to={"/view/hold"} className="ui right labeled icon small button grey">
                                        <Icon name="linkify" />
                                        View Holds
                                    </Button>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column width={4} className="wide">
                                <Segment className="grey">
                                    <h5 className="ui header"><i className="bell red icon"></i>Alerts Pending</h5>
                                    <p>[{this.props.items.countDetails.alertCount ? this.props.items.countDetails.alertCount : 0}]</p>
                                    <Button as={Link} to={"/alert"} className="ui right labeled icon small button grey">
                                        <Icon name="linkify" />
                                        View Alerts
                                    </Button>
                                </Segment>
                            </Grid.Column>
                            <Grid.Column width={4} className="wide">
                                <Segment className="grey">
                                    <h5 className="ui header"><i className="info circle icon"></i>Need Help?</h5>
                                    <p>We've got you covered.</p>
                                    <Button as={Link} to={"/userguide"} className="ui right labeled icon small button grey">
                                        <Icon name="linkify" />
                                        View Details
                                    </Button>
                                </Segment>
                            </Grid.Column>
                           {this.props.items.countDetails.showClientAction && <Grid.Column width={4} className="wide">
                                <Segment className="grey">
                                    <h5 className="ui header"><i className="bell green icon"></i>Client Actions</h5>
                                    <p>[{this.props.items.countDetails.clientAction ? this.props.items.countDetails.clientAction.length : 0}]</p>
                                    <Button as={Link} to={"/clientAction/0"} className="ui right labeled icon small button grey">
                                        <Icon name="linkify" />
                                        View Clients
                                    </Button>
                                </Segment>
                            </Grid.Column> }
                        </Grid>
                    </Grid.Column>
                </Grid>
                <Grid centered>
                    <VideoPlayer src={this.props.config.DASHBOARD_VIDEO_LINK} thumbnail={this.props.config.DASHBOARD_VIDEO_THUMBNAIL} />
                </Grid>
                {/*<Grid className="chart-body g-bkgd">
                    <Grid.Column>
                         <div className="chart-container">
                            <Bar
                                data={{
                                    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
                                    datasets: [{
                                        label: "Dataset #1",
                                        backgroundColor: "rgba(45,45,452,0.2)",
                                        borderColor: "rgba(182,182,182,3)",
                                        borderWidth: 1,
                                        hoverBackgroundColor: "rgba(24,90,169,0.85)",
                                        hoverBorderColor: "rgba(182,182,182,3)",
                                        data: [65, 59, 20, 81, 56, 55, 40],
                                    }]
                                }}
                                width={100}
                                height={50}
                                options={{
                                    scales: {
                                        yAxes: [{
                                            stacked: true,
                                            gridLines: {
                                                display: true,
                                                color: "rgba(45,45,452,0.2)"
                                            }
                                        }],
                                        xAxes: [{
                                            gridLines: {
                                                display: false
                                            }
                                        }]
                                    }
                                }}
                            />
                        </div> 
                    </Grid.Column>
                </Grid>*/}
            </div >
        );
    }
}
export default Dashboard;


// WEBPACK FOOTER //
// ./src/app/ui/Dashboard.js